<template>
  <transition name="slide-fade" appear mode="out-in">
    <div class="modal-component" :class="{ 'modal-show': modalComponentShow }">
      <div class="box-bg" @click.stop="modalClose"></div>
      <div :class="modalComponentType" v-if="modalComponentType == 'box'">
        <div class="btn-close" @click="modalClose">
          <img src="../../assets/images/modal/btn_close.svg" />
        </div>
        <transition name="slide-fade" appear mode="out-in">
          <keep-alive>
            <component
              v-bind:is="modalComponent"
              v-on:close="modalClose"
              :data="modalComponentPropData"
            ></component>
          </keep-alive>
        </transition>
      </div>
      <div v-else :class="modalComponentType">
        <div class="btn-close" @click="modalClose">
          <img src="../../assets/images/modal/btn_close.svg" />
        </div>
        <transition name="slide-fade" appear mode="out-in">
          <component
            v-bind:is="modalComponent"
            v-on:close="modalClose"
            :data="modalComponentPropData"
            class="component"
          ></component>
        </transition>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from '../../store/mutation-types'
import Profile from '../photographer/Profile'
import RequestPageMainLayout from '../requestPage/MainLayout'
import Signup from '../auth/signup/Signup.vue'
import Login from '../auth/login/Login.vue'
import SelectType from './SelectType'
import RequestMainLayout from '../request/MainLayout'
import GoogleMapViewerLayout from './GoogleMapViewerLayout'

export default {
  name: 'modal-component',
  components: {
    profile: Profile,
    requestPage: RequestPageMainLayout,
    signup: Signup,
    login: Login,
    selectType: SelectType,
    request: RequestMainLayout,
    googleMap: GoogleMapViewerLayout
  },
  methods: {
    modalClose() {
      this.$store.dispatch(types.RESET_SERVICE).then(() => {
        console.log('리셋')
        this.$store
          .dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
            component: '',
            propData: {}
          })
          .finally(() => {
            console.log('SET_MODAL_REQUEST_COMPONENT destroyed complete')
            this.$store
              .dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
                component: '',
                active: false,
                type: 'full'
              })
              .finally(() => {
                console.log('SET_MODAL_REQUEST_COMPONENT close complete')
                this.$store
                  .dispatch(types.SET_MODAL_COMPONENT, {
                    component: '',
                    active: false,
                    type: 'full'
                  })
                  .finally(() => {
                    console.log('Close request modal')
                  })
              })
          })
      })
    }
  },
  updated() {
    // console.log('madal com updated: ', this.modalComponent)
  },
  computed: {
    ...mapGetters([
      'modalComponentShow',
      'modalComponent',
      'modalComponentType',
      'modalComponentPropData'
    ])
  }
}
</script>
<style lang="scss" scoped>
.modal-component {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s ease-in-out, opacity 0.5s ease-in-out;
  -webkit-transition: visibility 0.5s ease-in-out, opacity 0.5s ease-in-out;

  .btn-close-hidden {
    visibility: hidden;
    opacity: 0;
  }

  // Use in type of full-screen case.
  .component {
    z-index: 1090;
  }

  .box-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    background-color: #ffffff;
    opacity: 0.9;
    z-index: 1000;
  }

  .box {
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 80%;
    height: 80%;
    background-color: #ffffff;
    z-index: 1080;
    border: solid 1px #e7e7e7;
    .btn-close {
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 80px;
      cursor: pointer;
      z-index: 1090;
      img {
        width: 80px;
        height: 80px;
      }
    }
  }

  .full {
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    z-index: 1080;
    border: solid 1px #e7e7e7;
    opacity: 1;
    .btn-close {
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 80px;
      cursor: pointer;
      z-index: 1090;
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
}

.modal-show {
  visibility: visible;
  opacity: 1;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
